import AlternateGameHeader from "../containers/alternate-game-header";
import classes from "../classes";
import { connect } from "react-redux";
import detectBreakpoint from "../components/higher-order/detect-breakpoint";
import GameBoardBanner from "../components/game-board-banner";
import GameBoardHeader from "../components/game-board-header";
import { getBets, getCommunications, getMyTicketsForTournament, getRacesForTournament, getRaceEntrants, getSession, getSurvivorsForTournament, getTicketsForTournament, getTokenTypes, getTournament, getUsers } from "../selectors";
import { isBreakpointGreaterThan } from "../breakpoints";
import Leaderboard from "../containers/leaderboard";
import LoadingModal from "../components/loading-modal";
import PlayField from "../components/play-field";
import progressiveLoad from "../components/higher-order/progressive-load";
import React from "react";
import { tournamentMakeAlternatePick, tournamentMakePick, tournamentSubscribe } from "../actions/tournament";

class GameBoard extends React.PureComponent {
  constructor(props) {
    super(props);

    var { communications, match, tournamentSubscribe: onTournamentSubscribe } = props;
    if (communications.getIn(["sessionConnect", "state"]) === "success") {
      onTournamentSubscribe(match.params.id);
    }
  }

  componentDidUpdate({ communications: prevCommunications, tournament }) {
    var { communications, match, tournamentSubscribe: onTournamentSubscribe } = this.props;
    if (this.didTournamentChange(tournament) ||
      (
        prevCommunications.getIn(["sessionConnect", "state"]) !== communications.getIn(["sessionConnect", "state"]) &&
        communications.getIn(["sessionConnect", "state"]) === "success"
      )
    ) {
      onTournamentSubscribe(match.params.id);
    }
  }

  didTournamentChange(t) {
    var { match, tournament } = this.props;
    return tournament !== t &&
      t !== undefined &&
      tournament !== undefined &&
      t.get("id") !== parseInt(match.params.id);
  }

  render() {
    var {
      bets,
      breakpoint,
      frame,
      myTicketsForTournament,
      raceEntrants,
      racesForTournament,
      session,
      survivors,
      tickets,
      tokenTypes,
      tournament,
      tournamentMakeAlternatePick: onMakeAlternatePick,
      tournamentMakePick: onMakePick,
      users
    } = this.props;

    if (tournament === undefined) {
      return (<LoadingModal />);
    }

    var leaderBoard;
    if (isBreakpointGreaterThan(breakpoint, "md") && frame >= 1) {
      leaderBoard = (<Leaderboard
        autoResize
        races={racesForTournament}
        tickets={tickets}
        tournament={tournament} />);
    }

    var pageSize = 3;
    var playField;
    if (frame >= 2) {
      playField = (<PlayField
        bets={bets}
        myTickets={myTicketsForTournament}
        onMakeAlternatePick={onMakeAlternatePick}
        onMakePick={onMakePick}
        pageSize={pageSize}
        raceEntrants={raceEntrants}
        races={racesForTournament}
        survivors={survivors}
        tickets={tickets}
        tokenTypes={tokenTypes}
        tournament={tournament}
        users={users} />);
    }

    return (
      <div className="l-wrapper l-wrapper--supersize">
        <div className={"l-content game-page game-page--tournament-status--" + tournament.get("status") + " game-page--tournament-type--" + tournament.get("tournament_type").toLowerCase()}>
          <div className="batch-g game-table_container">
            <div className={classes({
              "game-table_grid-cell": true,
              "game-table--has-base": myTicketsForTournament.size > 1,
              "game-table--has-scroll": myTicketsForTournament.size > pageSize
            })}>
              <GameBoardBanner
                racesForTournament={racesForTournament}
                session={session}
                tournament={tournament} />

              <AlternateGameHeader myTickets={myTicketsForTournament} tournament={tournament} />

              <GameBoardHeader
                myTickets={myTicketsForTournament}
                races={racesForTournament}
                tokenTypes={tokenTypes}
                tournament={tournament} />

              {playField}
            </div>

            {leaderBoard}
          </div>
        </div>
      </div>
    );
  }
}

function select(state, props) {
  return {
    bets: getBets(state),
    communications: getCommunications(state),
    myTicketsForTournament: getMyTicketsForTournament(state, props),
    racesForTournament: getRacesForTournament(state, props),
    raceEntrants: getRaceEntrants(state),
    session: getSession(state, props),
    survivors: getSurvivorsForTournament(state, props),
    tickets: getTicketsForTournament(state, props),
    tokenTypes: getTokenTypes(state),
    tournament: getTournament(state, props),
    users: getUsers(state)
  };
}

export default connect(select, { tournamentMakeAlternatePick, tournamentMakePick, tournamentSubscribe })(detectBreakpoint(progressiveLoad(3, GameBoard)));
